import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faCheckCircle, faTimesCircle } from '@fortawesome/free-regular-svg-icons';

import { UploadDocumentationsService } from 'src/app/shared/services/offer-services/upload-documentation.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-upload-documents',
  templateUrl: './upload-documents.component.html',
  styleUrls: ['./upload-documents.component.sass']
})
export class UploadDocumentsComponent implements OnInit {
  faCheckCircle = faCheckCircle;
  faTimesCircle = faTimesCircle;
  @ViewChild('docInput', { static: false }) myDocInputVariable: ElementRef;
  @ViewChild('succesModal', { static: false }) private succesModal;
  @ViewChild('alertModal', { static: false }) private alertModal;
  errorTitle: String;
  successTitle: String;

  responsivnes: Boolean = false
  filesMobile = [];
  file;
  offerID;
  token;
  constructor(private activatedRoute: ActivatedRoute, private uploadDocumentationsService: UploadDocumentationsService, private modalService: NgbModal) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.offerID = params['offerid'];
      this.token = params['token'];
    });
  }

  ngOnInit() {
    if (window.innerWidth < 768) {
      this.responsivnes = true;
    } else {
      this.responsivnes = false;
    }
  }

  onFileChanged(event) {
    // console.log(event.target.files[0]);
    if (this.responsivnes) {
      this.filesMobile.push(event.target.files[0]);
      this.myDocInputVariable.nativeElement.value = "";
    } else {
      // this.file = event.target.files;
      this.filesMobile = event.target.files
    }
  }

  uploadFiles() {
    const formData = new FormData();
    formData.append('Token', this.token);
    formData.append('OfferID', this.offerID);
    if (this.responsivnes) {
      if (this.filesMobile.length == 1) {
        formData.append('Files', this.filesMobile[0])
        this.uploadDocumentationsService.uploadDoc(formData)
          .subscribe(
            x => {
              console.log(x);
              this.filesMobile = [];
              this.successTitle = "Uspešno ste prebacili podatke";
              this.modalService.open(this.succesModal, { centered: true, backdrop: 'static' })
            },
            (e: {error: String}) => {
              console.log(e)
              this.errorTitle = e.error;
              this.modalService.open(this.alertModal, { centered: true })
            }
          )
      } else if (this.filesMobile.length > 1) {
        for (var i = 0; i < this.filesMobile.length; i++) {
          formData.append('Files', this.filesMobile[i])
        }
        this.uploadDocumentationsService.uploadDoc(formData)
          .subscribe(
            x => {
              console.log(x);
              this.filesMobile = [];
              this.successTitle = "Uspešno ste prebacili podatke";
              this.modalService.open(this.succesModal, { centered: true, backdrop: 'static' })
            },
            (e: {error: String}) => {
              console.log(e)
              this.errorTitle = e.error;
              this.modalService.open(this.alertModal, { centered: true })
            }
          )
      }
    } else {
      if (this.filesMobile.length == 1) {
        formData.append('Files', this.filesMobile[0])
        this.uploadDocumentationsService.uploadDoc(formData)
          .subscribe(
            x => {
              console.log(x);
              this.filesMobile = [];
              this.successTitle = "Uspešno ste prebacili podatke";
              this.modalService.open(this.succesModal, { centered: true, backdrop: 'static' })
            },
            (e: {error: String}) => {
              console.log(e)
              this.errorTitle = e.error;
              this.modalService.open(this.alertModal, { centered: true })
            }
          )
      } else if (this.filesMobile.length > 1) {
        for (var i = 0; i < this.filesMobile.length; i++) {
          formData.append('Files', this.filesMobile[i])
        }
        this.uploadDocumentationsService.uploadDoc(formData)
          .subscribe(
            x => {
              console.log(x);
              this.filesMobile = [];
              this.successTitle = "Uspešno ste prebacili podatke";
              this.modalService.open(this.succesModal, { centered: true, backdrop: 'static' })
            },
            (e: {error: String}) => {
              console.log(e)
              this.errorTitle = e.error;
              this.modalService.open(this.alertModal, { centered: true })
            }
          )
      }
    }

  }

}
